/**
 * Created by ganlu on 28/09/2016.
 */

import originalArticleComponent from './original-article.component';
import localStorageModule from 'angular-local-storage';
import publishToMedia from '../../../../modules/publish-to-media/publish-to-media';
import gatherBox from './gather-box/gather-box';
import copyCheck from './copy-check.directive';

let originalArticleModule = angular.module('originalArticle', [
    localStorageModule,
    publishToMedia,
    gatherBox
])

    .component('originalArticle', originalArticleComponent)
    .directive('copyCheck', copyCheck)

    .name;

let states = [
    {
        name: 'article',
        url: '/article/{id}?action&from',
        template: '<original-article set-error="$ctrl.setError(error)" set-reproduction="$ctrl.setReproduction(reproduction)" set-show-reproduction-detail="$ctrl.setShowReproductionDetail(show)" share-to-weixin="$ctrl.shareToWeixin(url)" app-user="$ctrl.appUser"></original-article>'
    },
    {
        name: 'articleHash',
        url: '/article/hash/{hash}',
        template: '<original-article set-error="$ctrl.setError(error)" set-reproduction="$ctrl.setReproduction(reproduction)" set-show-reproduction-detail="$ctrl.setShowReproductionDetail(show)" share-to-weixin="$ctrl.shareToWeixin(url)" app-user="$ctrl.appUser"></original-article>'
    },
    {
        name: 'articleReproduction',
        url: '/article/reproduction/{reproduction}',
        template: '<original-article set-error="$ctrl.setError(error)" set-reproduction="$ctrl.setReproduction(reproduction)" set-show-reproduction-detail="$ctrl.setShowReproductionDetail(show)" share-to-weixin="$ctrl.shareToWeixin(url)" app-user="$ctrl.appUser"></original-article>'
    }
];

export default {name: originalArticleModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/page/original/original-article/original-article.js